export default class BaseTra {
  async translate(text) {
    throw new Error('未實現translate()');
  }
}
